<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o56vtJ/tc-custom/9781398411753.jpg?1705056298005" alt="This image is the cover for the book Sex, Drugs and Pots & Pans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sex, Drugs and Pots & Pans
      </h1>
      <p class="bookDescription body article font2">
        <p>Do you love classic rock music and food, and cooking? If so, this is the perfect book for you, your family, and your friends. The greatest songs of the 60s, 70s and 80s combined with the tastiest meals globally all wrapped in one book. Cover to cover, you will rock and roll to your heart's delight.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wayne Sumbler
      </h2>
      
      <p class="authorDescription body article">Wayne Sumbler was born in the small town of Welland, Ontario, Canada in 1956. His first exposure to rock and roll was watching the Beatles on the Ed Sullivan show. His first guitar was an acoustic one that he received as a gift from his parents after having a serious accident by falling from a tree. He then proceeded to a Kent Electric guitar as a gift for Christmas, where he had learned to play his first real songs (surprisingly, that guitar disappeared until a few years ago, as he forgot it was left at a cousin’s home. It sat there for 40 years on a wall, until the cousin was reminded at a funeral that he still had it and Wayne got it back and now restoring it). The first song he learned to play was Love is all around by the Troggs and the second was Crimson and Clover by Tommy James and the Shondells (Oops, forgot the Monkees). Once he got into his mid and late teens, he purchased a white and black Les Paul guitar. He can still remember the first time that he was able to play Stairway to Heaven (All thanks to Kevin). That was when classic rock became part of his life. Led Zeppelin was his first love. He played in several bands that covered versions of Rush, Zeppelin, Pink Floyd, Boston, Cream, The Rolling Stones, Bowie, Black Sabbath, Kiss, Queen, Uriah Heep, Alice Cooper, Thin Lizzy, Jimi Hendrix, The Who, Roxy Music, ZZ Top, and many, many others. Now to his time as a cook. His mother was Italian, so you know where the genetics come from right? He proceeded to cook at various restaurants for a period of 4 plus years. He has cooked for the family in different locations in the world, picking up recipes as they went along. Singapore, Malaysia, Bali, Japan, England, France, Scotland and their latest, Italy. I really hope you enjoy the recipes he has provided as well as the YouTube links to the various bands. A special thank you goes to Carl as he gave Wayne the inspiration in creating this book. Yes, the author played with him as well, and they still jam quite often. This is a fun book and will provide recipes for every classic rock fan worldwide. Enjoy! Keep on Rockin’ Folks.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a72a0798